/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionHexLink2FragmentDoc } from "../../../hex-list-2/HexList2.generated";
import { ProjectsTableSafeOrUnknownHexFragmentDoc } from "../../../projects-table/ProjectsTable.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectionHexLinks2QueryVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  before: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  order: Types.InputMaybe<Types.Scalars["CollectionHexLinksOrderBy"]["input"]>;
  includeCreatorImgUrl?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  categories: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["CategoryId"]["input"]>
    | Types.Scalars["CategoryId"]["input"]
  >;
  statuses: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["StatusId"]["input"]>
    | Types.Scalars["StatusId"]["input"]
  >;
  collections: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["CollectionId"]["input"]>
    | Types.Scalars["CollectionId"]["input"]
  >;
  ownerIds: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["UserId"]["input"]>
    | Types.Scalars["UserId"]["input"]
  >;
  creatorIds: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["UserId"]["input"]>
    | Types.Scalars["UserId"]["input"]
  >;
  searchTerm: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  fields?: Types.InputMaybe<
    ReadonlyArray<Types.SearchHexesForHomeField> | Types.SearchHexesForHomeField
  >;
  sharedWithWorkspace?: Types.InputMaybe<Types.HexFilter>;
  projectRoles?: Types.InputMaybe<
    ReadonlyArray<Types.ProjectRole> | Types.ProjectRole
  >;
  sharedWithPublic?: Types.InputMaybe<Types.HexFilter>;
}>;

export type CollectionHexLinks2Query = {
  readonly __typename: "Query";
  readonly collectionHexLinks: {
    readonly __typename: "CollectionHexLinkConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "CollectionHexLinksEdge";
      readonly cursor: c.Cursor;
      readonly node: {
        readonly __typename: "CollectionHexLink";
        readonly id: c.CollectionHexLinkId;
        readonly projectRole: Types.ProjectRole | null;
        readonly safeOrUnknownHex:
          | {
              readonly __typename: "Hex";
              readonly id: c.HexId;
              readonly title: string;
              readonly description: c.RichTextDocument | null;
              readonly canShare: boolean;
              readonly canSetOwner: boolean;
              readonly maxGrantableRole: Types.ProjectRole | null;
              readonly canViewLogic: boolean;
              readonly effectiveRole: Types.ProjectRole | null;
              readonly trashDate: c.DateTimeString | null;
              readonly starredByViewer: boolean;
              readonly userUpdatedDate: c.DateTimeString;
              readonly hexType: Types.HexType;
              readonly lastViewedByMe: c.DateTimeString | null;
              readonly requiresReview: boolean;
              readonly resolvedRequiresReview: boolean;
              readonly hasEnabledSchedules: boolean;
              readonly allowEmbedding: boolean;
              readonly canDelete: boolean;
              readonly canEditMetadata: boolean;
              readonly canUseApp: boolean;
              readonly projectLanguage: Types.ProjectLanguage;
              readonly canEdit: boolean;
              readonly canEditorsShare: boolean;
              readonly archivedDate: c.DateTimeString | null;
              readonly unarchivedDate: c.DateTimeString | null;
              readonly publicRoleV2: Types.ProjectRole | null;
              readonly organizationRoleV2: Types.ProjectRole | null;
              readonly grantSummary: c.ProjectGrantSummary;
              readonly onlyGrantedToCurrentUser: boolean;
              readonly totalViewCount: number;
              readonly dateCreated: c.DateTimeString;
              readonly status: {
                readonly __typename: "Status";
                readonly enforcesReview: boolean;
                readonly id: c.StatusId;
                readonly name: string;
                readonly color: Types.HexColor;
                readonly description: string | null;
                readonly inLibrary: boolean;
                readonly endorsed: boolean;
                readonly icon: Types.IconType | null;
              } | null;
              readonly categories: ReadonlyArray<{
                readonly __typename: "Category";
                readonly id: c.CategoryId;
                readonly name: string;
                readonly color: Types.HexColor;
                readonly description: string | null;
              }>;
              readonly lastPublishedVersion: {
                readonly __typename: "HexVersion";
                readonly id: c.HexVersionId;
                readonly screenshotUrls: c.ScreenshotUrls | null;
                readonly dateCreated: c.DateTimeString;
                readonly denialReason:
                  | {
                      readonly __typename: "AssetAccess";
                      readonly hasAccessToSharedDataConnections: boolean;
                      readonly hasAccessToSharedFiles: boolean;
                      readonly hasAccessToSharedPackages: boolean;
                      readonly hasAccessToSharedSecrets: boolean;
                      readonly hasAccessToSharedSyncRepositories: boolean;
                    }
                  | { readonly __typename: "MissingProjectRole" }
                  | null;
              } | null;
              readonly currentDraft: {
                readonly __typename: "HexVersion";
                readonly createdDate: c.DateTimeString;
                readonly id: c.HexVersionId;
                readonly title: string;
                readonly logicSessionId: c.AppSessionId;
                readonly canEdit: boolean;
                readonly denialReason:
                  | {
                      readonly __typename: "AssetAccess";
                      readonly hasAccessToSharedDataConnections: boolean;
                      readonly hasAccessToSharedFiles: boolean;
                      readonly hasAccessToSharedPackages: boolean;
                      readonly hasAccessToSharedSecrets: boolean;
                      readonly hasAccessToSharedSyncRepositories: boolean;
                    }
                  | { readonly __typename: "MissingProjectRole" }
                  | null;
              };
              readonly owner: {
                readonly __typename: "User";
                readonly id: c.UserId;
                readonly name: string | null;
                readonly email: string;
                readonly imageUrl?: string | null;
              };
              readonly creator: {
                readonly __typename: "User";
                readonly id: c.UserId;
                readonly name: string | null;
                readonly email: string;
                readonly imageUrl?: string | null;
              };
              readonly collectionHexLink: {
                readonly __typename: "CollectionHexLink";
                readonly id: c.CollectionHexLinkId;
                readonly projectRole: Types.ProjectRole | null;
                readonly collection: {
                  readonly __typename: "Collection";
                  readonly id: c.CollectionId;
                };
              } | null;
              readonly safeCollectionHexLinks: ReadonlyArray<{
                readonly __typename: "CollectionHexLink";
                readonly id: c.CollectionHexLinkId;
                readonly collection: {
                  readonly __typename: "Collection";
                  readonly id: c.CollectionId;
                  readonly name: string;
                  readonly emoji: string | null;
                };
              }>;
              readonly org: {
                readonly __typename: "Org";
                readonly id: c.OrgId;
                readonly displayName: string;
                readonly allowPublicSharing: boolean;
                readonly resolvedAllowPublicSharing: boolean;
              };
              readonly projectAnalytics: {
                readonly __typename: "HexAnalytics";
                readonly id: c.HexAnalyticsId;
                readonly totalViewsLast7Days: number;
                readonly totalViewsLast14Days: number;
                readonly totalViewsLast30Days: number;
                readonly lastPublishedViewedDate: c.DateTimeString | null;
              };
            }
          | {
              readonly __typename: "UnknownHex";
              readonly id: c.HexId;
              readonly userUpdatedDate: c.DateTimeString;
              readonly hexType: Types.HexType;
              readonly creator: {
                readonly __typename: "User";
                readonly id: c.UserId;
                readonly name: string | null;
                readonly email: string;
              };
              readonly owner: {
                readonly __typename: "User";
                readonly id: c.UserId;
                readonly name: string | null;
                readonly email: string;
              };
            };
        readonly collection: {
          readonly __typename: "Collection";
          readonly id: c.CollectionId;
        };
      };
    }>;
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
  };
};

export type UpdateCollectionMetadata2MutationVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  name: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  emoji: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type UpdateCollectionMetadata2Mutation = {
  readonly __typename: "Mutation";
  readonly updateCollectionMetadata: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly name: string;
    readonly description: string | null;
    readonly emoji: string | null;
  };
};

export const CollectionHexLinks2Document = /*#__PURE__*/ gql`
  query CollectionHexLinks2(
    $collectionId: CollectionId!
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $order: CollectionHexLinksOrderBy
    $includeCreatorImgUrl: Boolean = false
    $categories: [CategoryId!]
    $statuses: [StatusId!]
    $collections: [CollectionId!]
    $ownerIds: [UserId!]
    $creatorIds: [UserId!]
    $searchTerm: String
    $fields: [SearchHexesForHomeField!] = [TITLE, CREATOR]
    $sharedWithWorkspace: HexFilter = INCLUDE
    $projectRoles: [ProjectRole!] = null
    $sharedWithPublic: HexFilter = INCLUDE
  ) {
    collectionHexLinks(
      first: $first
      last: $last
      before: $before
      after: $after
      order: $order
      collectionId: $collectionId
      collections: $collections
      categories: $categories
      statuses: $statuses
      ownerIds: $ownerIds
      creatorIds: $creatorIds
      searchTerm: $searchTerm
      fields: $fields
      sharedWithWorkspace: $sharedWithWorkspace
      projectRoles: $projectRoles
      sharedWithPublic: $sharedWithPublic
    ) {
      edges {
        cursor
        node {
          id
          ...CollectionHexLink2Fragment
          safeOrUnknownHex {
            ...ProjectsTableSafeOrUnknownHex
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
  ${CollectionHexLink2FragmentDoc}
  ${ProjectsTableSafeOrUnknownHexFragmentDoc}
`;

/**
 * __useCollectionHexLinks2Query__
 *
 * To run a query within a React component, call `useCollectionHexLinks2Query` and pass it any options that fit your needs.
 * When your component renders, `useCollectionHexLinks2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionHexLinks2Query({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      includeCreatorImgUrl: // value for 'includeCreatorImgUrl'
 *      categories: // value for 'categories'
 *      statuses: // value for 'statuses'
 *      collections: // value for 'collections'
 *      ownerIds: // value for 'ownerIds'
 *      creatorIds: // value for 'creatorIds'
 *      searchTerm: // value for 'searchTerm'
 *      fields: // value for 'fields'
 *      sharedWithWorkspace: // value for 'sharedWithWorkspace'
 *      projectRoles: // value for 'projectRoles'
 *      sharedWithPublic: // value for 'sharedWithPublic'
 *   },
 * });
 */
export function useCollectionHexLinks2Query(
  baseOptions: Apollo.QueryHookOptions<
    CollectionHexLinks2Query,
    CollectionHexLinks2QueryVariables
  > &
    (
      | { variables: CollectionHexLinks2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionHexLinks2Query,
    CollectionHexLinks2QueryVariables
  >(CollectionHexLinks2Document, options);
}
export function useCollectionHexLinks2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionHexLinks2Query,
    CollectionHexLinks2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionHexLinks2Query,
    CollectionHexLinks2QueryVariables
  >(CollectionHexLinks2Document, options);
}
export function useCollectionHexLinks2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionHexLinks2Query,
    CollectionHexLinks2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionHexLinks2Query,
    CollectionHexLinks2QueryVariables
  >(CollectionHexLinks2Document, options);
}
export type CollectionHexLinks2QueryHookResult = ReturnType<
  typeof useCollectionHexLinks2Query
>;
export type CollectionHexLinks2LazyQueryHookResult = ReturnType<
  typeof useCollectionHexLinks2LazyQuery
>;
export type CollectionHexLinks2SuspenseQueryHookResult = ReturnType<
  typeof useCollectionHexLinks2SuspenseQuery
>;
export type CollectionHexLinks2QueryResult = Apollo.QueryResult<
  CollectionHexLinks2Query,
  CollectionHexLinks2QueryVariables
>;
export const UpdateCollectionMetadata2Document = /*#__PURE__*/ gql`
  mutation UpdateCollectionMetadata2(
    $collectionId: CollectionId!
    $name: String
    $description: String
    $emoji: String
  ) {
    updateCollectionMetadata(
      collectionId: $collectionId
      name: $name
      description: $description
      emoji: $emoji
    ) {
      id
      name
      description
      emoji
    }
  }
`;
export type UpdateCollectionMetadata2MutationFn = Apollo.MutationFunction<
  UpdateCollectionMetadata2Mutation,
  UpdateCollectionMetadata2MutationVariables
>;

/**
 * __useUpdateCollectionMetadata2Mutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMetadata2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMetadata2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMetadata2Mutation, { data, loading, error }] = useUpdateCollectionMetadata2Mutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useUpdateCollectionMetadata2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionMetadata2Mutation,
    UpdateCollectionMetadata2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionMetadata2Mutation,
    UpdateCollectionMetadata2MutationVariables
  >(UpdateCollectionMetadata2Document, options);
}
export type UpdateCollectionMetadata2MutationHookResult = ReturnType<
  typeof useUpdateCollectionMetadata2Mutation
>;
export type UpdateCollectionMetadata2MutationResult =
  Apollo.MutationResult<UpdateCollectionMetadata2Mutation>;
export type UpdateCollectionMetadata2MutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCollectionMetadata2Mutation,
    UpdateCollectionMetadata2MutationVariables
  >;
